export default __webpack_public_path__ + "static/media/spoons.0d26fb1e.jpg";